import { combineReducers } from 'redux'
import userData from './user'
import OrderMenu from './order-menu'
import OrderNotification from './notification'
import searchData from "./search"

export default combineReducers({
  userData,
  OrderMenu,
  OrderNotification,
  searchData
})


// WEBPACK FOOTER //
// ./src/reducer/index.js